import type { PartnerAccountant } from '../../models/partnerAccountant.ts';
import { useQuery } from '@tanstack/react-query';
import { fetchPartnerAccountants } from '../../api/partner-accountant.ts';

export const usePartnerAccountants = (partnerId: string) => {
  return useQuery<PartnerAccountant[]>({
    queryKey: ['partnerAccountants', partnerId],
    queryFn: () => fetchPartnerAccountants(partnerId),
  });
};
